<template>
    <div class="not-found-card bg-color">
        <h1>404</h1>
        <p>Page Not Found</p>
        <router-link to="/">Go Back Home</router-link>
    </div>
</template>

<script>
export default {
    name: "PageNotFound",
};
</script>

<style scoped>
.not-found-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 40px;
    margin: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.not-found-card h1 {
    font-size: 72px;
    margin: 0;
}

.not-found-card p {
    font-size: 24px;
    margin: 10px 0;
    color: #343a40;
}

.not-found-card a {
    text-decoration: none;
    color: #007bff;
    font-weight: bold;
    margin-top: 20px;
    transition: color 0.3s;
}

.bg-color {
    color: #365b6d;
}

.not-found-card a:hover {
    color: #0056b3;
}

</style>